import { createFileRoute, redirect } from '@tanstack/react-router';

// FSU shell unification: the pre-FSU /sources URL is retired. Sources lives
// under the new Settings sub-nav. Existing bookmarks redirect.
export const Route = createFileRoute('/admin/finance/sources')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/finance/settings/sources' });
  },
});
